<template>
  <div>
    <v-dialog v-model="toggle" persistent width="450">
      <v-card outlined class="r0" style="border: 0px !important">
        <v-card
          outlined
          style="padding: 20px; color: #ffffff; border: 0px !important"
          class="r0 text-center bg-two-tone"
        >
          <h2 class="text-center">{{ $t('Warning') }}</h2>
        </v-card>
        <v-container>
          <template>
            <p class="mt-2">
              {{ $t('LINE OA account cannot be changed once it is set.') }}
            </p>

            <v-checkbox
              v-model="checkboxSetAll"
              :label="$t('set this rich menu as default.')"
              :disabled="showAdvance"
            ></v-checkbox>
            <!-- <div style="margin-left: 37%">
              <v-checkbox class="mt-10" v-model="confirm" :label="`I Agree`"></v-checkbox>
            </div> -->
            <template>
              <div class="btn-sticky mt-10 pr-pl-12">
                <v-btn
                  outlined
                  class="btn-back-richmenu w45 br-7"
                  @click="back"
                  >{{ $t('Back') }}</v-btn
                >
                <v-btn
                  outlined
                  class="btn-custom btn-next-richmenu w45 right"
                  @click="submitData"
                  ><span>{{ $t('Yes, I sure') }}</span>
                </v-btn>
              </div>
            </template>
          </template>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
// import imageSetting from "../../mixins/imageSetting";
export default {
  props: [
    'value',
    'dataConnect',
    'select',
    'Channel',
    'setDataTime',
    'showAdvance'
  ],
  data() {
    return {
      toggle: this.value,
      // confirm: false,
      weekday: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      setTemplate: {},
      checkboxSetAll: true,
      templateMockup: {}
    }
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect'
    })
  },
  created() {
    this.setTemplate = this.templateSelect
    this.templateMockup = JSON.stringify(this.templateSelect)
  },
  mounted() {
    if (this.showAdvance) {
      this.checkboxSetAll = false
    }
  },
  methods: {
    async goToPageConfirmConnect() {
      this.$store.dispatch('setOverlay', true)
      if (typeof this.select === 'string') {
        this.dataConnect.channel_id = this.select
        var res = await this.$store.dispatch(
          'channelIdManager/postCreateChannel',
          {
            ...this.dataConnect
          }
        )
        if (res) {
          this.templateSelect.connected_channel_id =
            res.data.platform_channel_id
        }
      } else if (this.Channel) {
        this.templateSelect.connected_channel_id = this.Channel.id
      } else {
        this.templateSelect.connected_channel_id =
          this.dataConnect.platform_channel_id
      }
      var response = await this.$store.dispatch(
        'lineRichmenuManager/putTemplateSelect',
        [this.templateSelect]
      )
      if (response && !response._isError) {
        this.$store.dispatch('setOverlay', false)
        this.connect()
        // this.$emit("goToPage", 9);
        // this.dialog = true;
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong, Check your channel ID and secret ID.`
        })
      }
    },
    async submitData() {
      if (this.setTemplate.status && this.setTemplate.ref_index) {
        this.$store.dispatch('setOverlay', true)
        var resStop = await this.$store.dispatch(
          'lineRichmenuManager/stopRichmenu',
          this.setTemplate.id
        )
        if (resStop) {
          this.setTemplate.status = false
          this.goToPageConfirmConnect()
        }
      } else {
        this.goToPageConfirmConnect()
      }
    },
    async connect() {
      this.$emit('input', false)

      this.setTemplate.content_json.areas.map((item, i) => {
        if (item.action.type === 'phone_number') {
          item.action.type = 'uri'
          this.$set(
            this.setTemplate.content_json.areas[i].action,
            'uri',
            'tel:' + item.action['phone_number']
          )
          delete this.setTemplate.content_json.areas[i].action.phone_number
        } else if (item.action.type === 'uri') {
          let uri = item.action.uri
          if (
            uri.includes('https://line.me/R/') ||
            uri.includes('https://liff.line.me/') ||
            uri.includes('https%3A%2F%2Fline.me%2FR%2F')
          ) {
            this.$set(
              this.setTemplate.content_json.areas[i].action,
              'uri',
              `${uri}`
            )
          } else {
            this.$set(
              this.setTemplate.content_json.areas[i].action,
              'uri',
              `http://link.zwiz.ai/LineRichmenuStat?rm=${this.setTemplate.id}&rurl=${uri}`
            )
          }
        } else if (item.action.type === 'rich_menu') {
          item.action.type = 'postback'
        } else if (item.action.type === 'postback') {
          // this.$set(
          //   this.setTemplate.content_json.areas[i].action,
          //   "data",
          //   `pb=${this.setTemplate.id}|${item.action.data}`
          // );
        }
      })
      var jsonStr = JSON.stringify(this.setTemplate.content_json)
      this.setTemplate.content_json = jsonStr
      var response = await this.$store.dispatch(
        'lineRichmenuManager/putTemplateSelect',
        [this.setTemplate]
      )
      if (response && !response._isError) {
        let data = null
        data = {
          data: {
            line_richmenu_id: response.data.data[0].id,
            is_default: this.checkboxSetAll
          }
        }
        if (this.showAdvance) {
          data.set_default_schedule = [
            {
              start_at: `${this.setDataTime.date} ${this.setDataTime.time}:00`,
              end_at: `${this.setDataTime.date2} ${this.setDataTime.time2}:00`
            }
          ]

          if (
            this.setDataTime &&
            this.setDataTime.weekDate &&
            this.setDataTime.weekDate.length > 0
          ) {
            data.set_default_schedule = []
            let days = []

            this.getDatesInRange(
              this.setDataTime.date,
              this.setDataTime.date2
            ).map((item) => {
              if (
                this.setDataTime.weekDate.includes(this.weekday[item.getDay()])
              ) {
                days.push(dayjs(item).format('YYYY-MM-DD'))
              }
            })
            days.map((item) => {
              data.set_default_schedule.push({
                start_at: `${item} 00:00:00`,
                end_at: `${dayjs(item)
                  .add(1, 'day')
                  .format('YYYY-MM-DD')} 00:00:00`
              })
            })
          }
          data.set_default_schedule_setting = {
            start_date_at: this.setDataTime.date,
            start_time_at: `${this.setDataTime.time}:00`,
            end_date_at: this.setDataTime.date2,
            end_time_at: `${this.setDataTime.time2}:00`,
            date: this.setDataTime.weekDate
          }
          try {
            data.set_default_schedule_setting = JSON.stringify(
              data.set_default_schedule_setting
            )
          } catch (error) {
            console.error(error)
          }
        }
        var res = await this.$store.dispatch(
          'lineRichmenuManager/startRichmenu',
          data
        )
        if (res.status) {
          var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
          this.$gtag.event('event', {
            event_category: prefix + 'Connect line OA success'
            // event_label: bot.pagename + utm,
          })
          // console.log(res);
          this.$store.dispatch('setOverlay', false)
          const path = `/${this.currentLang}/richmenu`
          if (this.$route.path !== path) {
            this.$router.push({ path })
          }
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Success',
            text: 'Your richmenu has been connected. '
          })
          // var file = imageSetting.methods.dataURItoBlob(img.src);
          // console.log(file);
        } else {
          this.$store.dispatch('setOverlay', false)
          await this.$store.dispatch('lineRichmenuManager/putTemplateSelect', [
            JSON.parse(this.templateMockup)
          ])
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: res
          })
        }
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `something went wrong, please try again.`
        })
      }
    },
    back() {
      this.$emit('input', false)
    },
    getDatesInRange(startDate, endDate) {
      for (
        var arr = [], dt = new Date(startDate);
        dt <= new Date(endDate);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt))
      }
      return arr
    }
  }
}
</script>

<style lang="scss" scoped></style>
